// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* src/pages/ItBacklog/ItBacklog.module.scss */
/* Переменные */
/* Page */
.ItBacklog_page__pHSJG {
  padding: 1rem 0 2rem;
}

/* Top summary + dept load */
.ItBacklog_topGrid__jdlsQ {
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  gap: 1rem;
}
@media (max-width: 980px) {
  .ItBacklog_topGrid__jdlsQ {
    grid-template-columns: 1fr;
  }
}

.ItBacklog_summaryCard__dCTLC,
.ItBacklog_loadCard__QMBUQ {
  background: #fff;
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  padding: 1rem;
}

.ItBacklog_summaryTitle__BMwhW {
  font-weight: 800;
  color: #333;
  margin-bottom: 0.75rem;
}

.ItBacklog_summaryRow__EAgAL {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
}
@media (max-width: 560px) {
  .ItBacklog_summaryRow__EAgAL {
    grid-template-columns: 1fr;
  }
}

.ItBacklog_summaryItem__l1pj1 {
  border: 1px solid #e6e8ef;
  border-radius: 10px;
  padding: 0.75rem;
  background: #fafbff;
}

.ItBacklog_kpi__SyXwh {
  font-size: 1.65rem;
  font-weight: 900;
  line-height: 1.1;
  color: #333;
}

.ItBacklog_kpiLabel__jkUPI {
  margin-top: 0.2rem;
  font-size: 0.9rem;
  color: #666;
}

.ItBacklog_legend__3H9Pk {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 0.75rem;
}

.ItBacklog_summaryActions__H8JaM {
  margin-top: 0.9rem;
  display: flex;
  justify-content: flex-start;
}

.ItBacklog_smallText__SuQVo {
  font-size: 0.9rem;
  color: #666;
}

/* Load card */
.ItBacklog_loadHeader__mJW1r {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
}

.ItBacklog_loadList__vQhnY {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.ItBacklog_loadItem__zUkEY {
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  padding: 0.75rem;
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 0.75rem;
  background: #fff;
}
@media (max-width: 560px) {
  .ItBacklog_loadItem__zUkEY {
    grid-template-columns: 1fr;
  }
}

.ItBacklog_loadDept__8NV2u {
  font-weight: 800;
  color: #333;
}

.ItBacklog_loadMeta__71bem {
  margin-top: 0.35rem;
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.ItBacklog_loadRight__sCSSq {
  display: flex;
  align-items: center;
}

.ItBacklog_bars__asgSr {
  width: 100%;
}

.ItBacklog_barTrack__HBygL {
  height: 10px;
  border-radius: 999px;
  background: #eef1f7;
  position: relative;
  overflow: hidden;
  display: flex;
}

.ItBacklog_barFill__3FtFb {
  height: 100%;
}

/* Tabs */
.ItBacklog_tabs__SzlNB {
  background: #fff;
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  margin-top: 1rem;
  padding: 0.4rem;
  display: inline-flex;
  gap: 0.35rem;
}

.ItBacklog_tabBtn__FTmBw {
  border: 1px solid transparent;
  background: transparent;
  border-radius: 10px;
  padding: 0.55rem 0.85rem;
  cursor: pointer;
  font-weight: 800;
  color: #666;
  transition: 0.2s;
}
.ItBacklog_tabBtn__FTmBw:hover {
  background: rgba(52, 152, 219, 0.08);
  color: #333;
}

.ItBacklog_tabActive__V8y1r {
  background: rgba(52, 152, 219, 0.12);
  border-color: rgba(52, 152, 219, 0.28);
  color: #333;
}

/* Toolbar / filters */
.ItBacklog_toolbar__qp4Wx {
  background: #fff;
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  margin-top: 1rem;
  padding: 0.75rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
}

.ItBacklog_searchWrap__n4Rtu {
  width: 100%;
}

.ItBacklog_search__gS39s {
  width: 100%;
  border: 1px solid #e6e8ef;
  border-radius: 10px;
  padding: 0.65rem 0.85rem;
  font-size: 1rem;
  outline: none;
}
.ItBacklog_search__gS39s:focus {
  border-color: rgba(52, 152, 219, 0.7);
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.12);
}

.ItBacklog_filters__4f4xS {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 0.6rem;
}
@media (max-width: 980px) {
  .ItBacklog_filters__4f4xS {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 560px) {
  .ItBacklog_filters__4f4xS {
    grid-template-columns: 1fr;
  }
}

.ItBacklog_select__hUuLk {
  width: 100%;
  border: 1px solid #e6e8ef;
  border-radius: 10px;
  padding: 0.6rem 0.75rem;
  background: #fff;
  outline: none;
}
.ItBacklog_select__hUuLk:focus {
  border-color: rgba(52, 152, 219, 0.7);
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.12);
}

.ItBacklog_viewToggle__lLTcY {
  display: flex;
  gap: 0.35rem;
  justify-content: flex-end;
}
@media (max-width: 980px) {
  .ItBacklog_viewToggle__lLTcY {
    justify-content: flex-start;
  }
}

.ItBacklog_toggleBtn__5kFi9 {
  border: 1px solid #e6e8ef;
  background: #fff;
  border-radius: 10px;
  padding: 0.55rem 0.75rem;
  cursor: pointer;
  transition: 0.2s;
  font-weight: 800;
}
.ItBacklog_toggleBtn__5kFi9:hover {
  border-color: rgba(52, 152, 219, 0.55);
}

.ItBacklog_active__mUeEA {
  border-color: rgba(52, 152, 219, 0.8);
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.12);
}

/* Buttons / inputs (shared) */
.ItBacklog_primaryBtn__C\\+7-D {
  border: 1px solid rgba(52, 152, 219, 0.45);
  background: rgba(52, 152, 219, 0.12);
  color: rgb(34.6744769874, 130.9924686192, 195.5255230126);
  border-radius: 10px;
  padding: 0.55rem 0.85rem;
  cursor: pointer;
  font-weight: 900;
  transition: 0.2s;
}
.ItBacklog_primaryBtn__C\\+7-D:hover {
  background: rgba(52, 152, 219, 0.18);
  border-color: rgba(52, 152, 219, 0.65);
}

.ItBacklog_actionBtn__doOIf {
  border: 1px solid #e6e8ef;
  background: #fff;
  border-radius: 10px;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  transition: 0.2s;
  font-weight: 800;
}
.ItBacklog_actionBtn__doOIf:hover {
  border-color: rgba(52, 152, 219, 0.55);
  background: rgba(52, 152, 219, 0.06);
}

.ItBacklog_input__sI8xA {
  width: 100%;
  border: 1px solid #e6e8ef;
  border-radius: 10px;
  padding: 0.6rem 0.75rem;
  background: #fff;
  outline: none;
}
.ItBacklog_input__sI8xA:focus {
  border-color: rgba(52, 152, 219, 0.7);
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.12);
}

.ItBacklog_textarea__jRs7c {
  width: 100%;
  border: 1px solid #e6e8ef;
  border-radius: 10px;
  padding: 0.65rem 0.75rem;
  background: #fff;
  outline: none;
  resize: vertical;
}
.ItBacklog_textarea__jRs7c:focus {
  border-color: rgba(52, 152, 219, 0.7);
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.12);
}

.ItBacklog_label__j-C7j {
  font-weight: 800;
  color: #333;
  margin-bottom: 0.35rem;
  font-size: 0.92rem;
}

.ItBacklog_sectionTitle__YpEoD {
  margin-top: 0.8rem;
  margin-bottom: 0.5rem;
  font-weight: 900;
  color: #333;
}

/* Kanban */
.ItBacklog_kanban__kBEFP {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
@media (max-width: 980px) {
  .ItBacklog_kanban__kBEFP {
    grid-template-columns: 1fr;
  }
}

.ItBacklog_column__3YyFx {
  background: #fff;
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  padding: 0.75rem;
  min-height: 220px;
}

.ItBacklog_columnHeader__I8fgC {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.6rem;
  border-bottom: 1px solid #e6e8ef;
  margin-bottom: 0.75rem;
}

.ItBacklog_columnCount__brEBK {
  font-weight: 900;
  color: #666;
}

.ItBacklog_cards__uj4F6 {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.ItBacklog_taskCard__gVDjd {
  text-align: left;
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  background: #fff;
  padding: 0.75rem;
  cursor: pointer;
  transition: 0.15s;
}
.ItBacklog_taskCard__gVDjd:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.07);
}

.ItBacklog_taskTop__lYqi1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
}

.ItBacklog_taskId__nJA-I {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-weight: 900;
  color: #666;
}

.ItBacklog_taskTitle__MAiN0 {
  font-weight: 900;
  color: #333;
  margin-bottom: 0.45rem;
  line-height: 1.25;
}

.ItBacklog_taskMetaRow__wrOM9 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
}
@media (max-width: 560px) {
  .ItBacklog_taskMetaRow__wrOM9 {
    grid-template-columns: 1fr;
  }
}

.ItBacklog_taskMeta__RmXpn {
  font-size: 0.92rem;
  color: #666;
}

.ItBacklog_metaLabel__IFfnC {
  color: #333;
  font-weight: 800;
}

.ItBacklog_taskBottom__zLhfF {
  display: flex;
  justify-content: space-between;
  margin-top: 0.45rem;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.ItBacklog_tags__Xjxgo {
  margin-top: 0.55rem;
  display: flex;
  gap: 0.35rem;
  flex-wrap: wrap;
}

.ItBacklog_tag__uEExO {
  border: 1px solid #e6e8ef;
  background: #fafbff;
  border-radius: 999px;
  padding: 0.2rem 0.55rem;
  font-size: 0.85rem;
  color: #666;
}

/* Table */
.ItBacklog_tableWrap__OSMSn {
  margin-top: 1rem;
  background: #fff;
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  overflow: auto;
}

.ItBacklog_table__raFyM {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}
.ItBacklog_table__raFyM th,
.ItBacklog_table__raFyM td {
  padding: 0.7rem 0.8rem;
  border-bottom: 1px solid #e6e8ef;
  vertical-align: top;
  white-space: nowrap;
}
.ItBacklog_table__raFyM th {
  position: sticky;
  top: 0;
  background: #fafbff;
  z-index: 1;
  text-align: left;
  font-weight: 900;
  color: #333;
}

.ItBacklog_rowClickable__OYFDP {
  cursor: pointer;
}
.ItBacklog_rowClickable__OYFDP:hover {
  background: rgba(52, 152, 219, 0.06);
}

.ItBacklog_mono__6qyI8 {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

/* Badges / pills / prio */
.ItBacklog_badge__JyE25 {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.2rem 0.6rem;
  font-size: 0.85rem;
  border: 1px solid #e6e8ef;
  background: #fafbff;
  color: #333;
  font-weight: 800;
}

.ItBacklog_pill__9yEt1 {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.18rem 0.55rem;
  font-size: 0.85rem;
  border: 1px solid #e6e8ef;
  background: #fff;
  color: #666;
  font-weight: 800;
}

.ItBacklog_queue__yJX\\+i {
  background: rgba(243, 156, 18, 0.12);
  border-color: rgba(243, 156, 18, 0.35);
  color: rgb(161.0457831325, 101.9277108434, 8.1542168675);
}

.ItBacklog_progress__j59OX {
  background: rgba(41, 128, 185, 0.12);
  border-color: rgba(41, 128, 185, 0.35);
  color: rgb(31.7477876106, 99.1150442478, 143.2522123894);
}

.ItBacklog_done__7Mc4I {
  background: rgba(46, 204, 113, 0.12);
  border-color: rgba(46, 204, 113, 0.35);
  color: rgb(34.7392, 154.0608, 85.3376);
}

.ItBacklog_prio__CWR9r {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.18rem 0.55rem;
  font-size: 0.85rem;
  border: 1px solid #e6e8ef;
  background: #fff;
  color: #666;
  font-weight: 900;
}

.ItBacklog_low__dhEyo {
  background: rgba(127, 140, 141, 0.12);
  border-color: rgba(127, 140, 141, 0.35);
  color: rgb(102.2231404959, 113.8801652893, 114.7768595041);
}

.ItBacklog_medium__WlseD {
  background: rgba(142, 68, 173, 0.12);
  border-color: rgba(142, 68, 173, 0.35);
  color: rgb(123.9701244813, 59.3659751037, 151.0340248963);
}

.ItBacklog_high__7CyhP {
  background: rgba(192, 57, 43, 0.12);
  border-color: rgba(192, 57, 43, 0.35);
  color: rgb(166.9991489362, 49.5778723404, 37.4008510638);
}

/* Plan tab */
.ItBacklog_planToolbar__IG8VS {
  background: #fff;
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  margin-top: 1rem;
  padding: 0.75rem;
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 0.75rem;
}
@media (max-width: 980px) {
  .ItBacklog_planToolbar__IG8VS {
    grid-template-columns: 1fr;
  }
}

.ItBacklog_monthNav__rTD8w {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ItBacklog_monthTitle__64OgX {
  font-weight: 900;
  color: #333;
  text-transform: capitalize;
}

.ItBacklog_planHint__XtrSB {
  display: flex;
  align-items: center;
}

.ItBacklog_planGrid__G6Ng9 {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.ItBacklog_calendarCard__rCy6o,
.ItBacklog_matrixCard__dLai2 {
  background: #fff;
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  padding: 1rem;
}

/* Calendar */
.ItBacklog_calendar__2Nakd {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.6rem;
}
@media (max-width: 980px) {
  .ItBacklog_calendar__2Nakd {
    gap: 0.5rem;
  }
}
@media (max-width: 560px) {
  .ItBacklog_calendar__2Nakd {
    grid-template-columns: repeat(2, 1fr);
  }
}

.ItBacklog_dayCell__gQsWW {
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  background: #fff;
  padding: 0.6rem;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.ItBacklog_weekend__675Ls {
  background: #fbfbfe;
  border-color: rgba(230, 232, 239, 0.9);
}

.ItBacklog_dayTop__2\\+R0a {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.ItBacklog_dayNum__NfXmE {
  font-weight: 900;
  color: #333;
  font-size: 1rem;
}

.ItBacklog_dayDow__LJsMe {
  font-weight: 900;
  color: #666;
  font-size: 0.85rem;
}

.ItBacklog_dayTasks__ERqnf {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.ItBacklog_dayTaskChip__\\+GqCz {
  width: 100%;
  text-align: left;
  border: 1px solid #e6e8ef;
  background: #fafbff;
  border-radius: 10px;
  padding: 0.35rem 0.45rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  transition: 0.15s;
}
.ItBacklog_dayTaskChip__\\+GqCz:hover {
  background: rgba(52, 152, 219, 0.08);
  border-color: rgba(52, 152, 219, 0.35);
}

.ItBacklog_dot__ZRltk {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  border: 1px solid rgba(230, 232, 239, 0.9);
  flex: 0 0 auto;
}

.ItBacklog_chipText__A-hMs {
  font-size: 0.85rem;
  color: #333;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ItBacklog_more__3dTdD {
  font-size: 0.82rem;
  color: #666;
  font-weight: 800;
}

.ItBacklog_dayEmpty__43KUG {
  font-size: 0.9rem;
  color: #666;
  opacity: 0.8;
}

/* Matrix */
.ItBacklog_matrixWrap__IMXpt {
  margin-top: 0.6rem;
  overflow: auto;
  border: 1px solid #e6e8ef;
  border-radius: 12px;
}

.ItBacklog_matrix__ZbS-q {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  min-width: 980px;
}
.ItBacklog_matrix__ZbS-q th,
.ItBacklog_matrix__ZbS-q td {
  border-bottom: 1px solid #e6e8ef;
  border-right: 1px solid #e6e8ef;
  padding: 0.45rem 0.45rem;
  vertical-align: top;
  background: #fff;
}
.ItBacklog_matrix__ZbS-q th {
  position: sticky;
  top: 0;
  z-index: 3;
  background: #fafbff;
  font-weight: 900;
  color: #333;
  text-align: center;
}

.ItBacklog_stickyCol__Py95v {
  position: sticky;
  left: 0;
  z-index: 4;
  background: #fafbff;
  min-width: 140px;
  text-align: left !important;
}

.ItBacklog_ownerCell__k3A74 {
  font-weight: 900;
  color: #333;
}

.ItBacklog_headDay__tc-t- {
  font-weight: 900;
  color: #333;
  line-height: 1.1;
}

.ItBacklog_headDow__pCtij {
  font-size: 0.8rem;
  color: #666;
  font-weight: 800;
  margin-top: 0.1rem;
}

.ItBacklog_weekendHead__LYIlL {
  background: #f3f4fb !important;
}

.ItBacklog_matrixCell__4YA9y {
  min-width: 56px;
  height: 46px;
}

.ItBacklog_weekendCell__AXMXB {
  background: #fbfbfe !important;
}

.ItBacklog_cellHours__o-Kyw {
  font-weight: 900;
  color: #333;
  font-size: 0.92rem;
  line-height: 1.1;
}

.ItBacklog_cellTasks__kq8DH {
  margin-top: 0.15rem;
  font-size: 0.75rem;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Intensity classes (referenced from calcIntensityClass) */
.ItBacklog_cell0__kmSaM {
  background: #fff;
}

.ItBacklog_cell1__Rek77 {
  background: rgba(46, 204, 113, 0.1);
}

.ItBacklog_cell2__5nbUB {
  background: rgba(243, 156, 18, 0.1);
}

.ItBacklog_cell3__uBgUI {
  background: rgba(41, 128, 185, 0.12);
}

.ItBacklog_cell4__L7y0E {
  background: rgba(192, 57, 43, 0.12);
}

/* Matrix legend */
.ItBacklog_matrixLegend__3Fp-H {
  margin-top: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-wrap: wrap;
}

.ItBacklog_legendBox__r70OX {
  width: 16px;
  height: 12px;
  border-radius: 4px;
  border: 1px solid #e6e8ef;
  display: inline-block;
}

/* Modal (shared) */
.ItBacklog_modalBackdrop__2DP36 {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  z-index: 9999;
}

.ItBacklog_modal__j9sYr {
  width: 100%;
  max-width: 820px;
  background: #fff;
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  padding: 1rem;
  max-height: 85vh;
  overflow: auto;
}

.ItBacklog_modalHeader__9FRrl {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e6e8ef;
  margin-bottom: 0.75rem;
}

.ItBacklog_modalTitle__DLrX- {
  font-weight: 900;
  color: #333;
  font-size: 1.15rem;
  line-height: 1.25;
}

.ItBacklog_modalSub__Eu9MV {
  margin-top: 0.25rem;
  color: #666;
  font-size: 0.92rem;
}

.ItBacklog_modalClose__reGbl {
  border: 1px solid #e6e8ef;
  background: #fff;
  border-radius: 10px;
  width: 38px;
  height: 38px;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  transition: 0.15s;
}
.ItBacklog_modalClose__reGbl:hover {
  border-color: rgba(52, 152, 219, 0.55);
  background: rgba(52, 152, 219, 0.06);
}

.ItBacklog_modalBody__4KqEy {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.ItBacklog_modalGrid__w83Mj {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.6rem;
}
@media (max-width: 980px) {
  .ItBacklog_modalGrid__w83Mj {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 560px) {
  .ItBacklog_modalGrid__w83Mj {
    grid-template-columns: 1fr;
  }
}

.ItBacklog_modalCard__dWScF {
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  padding: 0.75rem;
  background: #fafbff;
}

.ItBacklog_modalLabel__stG9w {
  font-size: 0.85rem;
  color: #666;
  font-weight: 900;
}

.ItBacklog_modalValue__IAEtD {
  margin-top: 0.35rem;
  color: #333;
  font-weight: 900;
}

.ItBacklog_modalActions__ezSqF {
  margin-top: 0.6rem;
  display: flex;
  gap: 0.35rem;
  flex-wrap: wrap;
}

.ItBacklog_modalSection__8pWiv {
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  padding: 0.75rem;
  background: #fff;
}

.ItBacklog_modalText__G5u3o {
  margin-top: 0.35rem;
  color: #333;
  line-height: 1.45;
}

.ItBacklog_modalTags__ZShe2 {
  margin-top: 0.45rem;
  display: flex;
  gap: 0.35rem;
  flex-wrap: wrap;
}

/* Subtasks */
.ItBacklog_subtasks__dJYn6 {
  margin-top: 0.45rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.ItBacklog_subtaskRow__Afmxv {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  color: #333;
  font-weight: 700;
}
.ItBacklog_subtaskRow__Afmxv input {
  transform: translateY(1px);
}

.ItBacklog_subtaskDone__oLRMH {
  text-decoration: line-through;
  color: #666;
}

/* Schedule list (task modal) */
.ItBacklog_scheduleList__7VYcS {
  margin-top: 0.45rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.ItBacklog_scheduleItem__fYSiD {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e6e8ef;
  background: #fafbff;
  border-radius: 10px;
  padding: 0.45rem 0.6rem;
}

.ItBacklog_scheduleDate__geLWi {
  font-weight: 900;
  color: #333;
}

.ItBacklog_scheduleHours__NGrdb {
  font-weight: 900;
  color: #666;
}

/* Comments */
.ItBacklog_comments__r4gPB {
  margin-top: 0.45rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.ItBacklog_commentCard__nsw-K {
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  padding: 0.65rem 0.75rem;
  background: #fafbff;
}

.ItBacklog_commentTop__mr2f\\+ {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.ItBacklog_commentAuthor__WwH2D {
  font-weight: 900;
  color: #333;
}

.ItBacklog_commentDate__qTCCy {
  font-size: 0.85rem;
  color: #666;
  font-weight: 800;
}

.ItBacklog_commentText__uhRHA {
  margin-top: 0.35rem;
  color: #333;
  line-height: 1.45;
}

.ItBacklog_commentForm__bZ0R9 {
  margin-top: 0.65rem;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.6rem;
}
@media (max-width: 560px) {
  .ItBacklog_commentForm__bZ0R9 {
    grid-template-columns: 1fr;
  }
}

.ItBacklog_mutedBlock__tssUK {
  margin-top: 0.35rem;
  color: #666;
  font-size: 0.92rem;
}

/* Create task modal form */
.ItBacklog_formGrid__FUP7E {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}
@media (max-width: 560px) {
  .ItBacklog_formGrid__FUP7E {
    grid-template-columns: 1fr;
  }
}

.ItBacklog_field__TUY5D {
  display: flex;
  flex-direction: column;
}

.ItBacklog_fieldFull__GXNac {
  grid-column: 1/-1;
  display: flex;
  flex-direction: column;
}

.ItBacklog_planMode__qDHnM {
  display: flex;
  gap: 0.35rem;
  flex-wrap: wrap;
  margin: 0.25rem 0 0.5rem;
}

.ItBacklog_checkRow__dSqeZ {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  font-weight: 800;
  color: #333;
}
.ItBacklog_checkRow__dSqeZ input {
  transform: translateY(1px);
}

.ItBacklog_modalFooter__ou2sq {
  margin-top: 0.9rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.ItBacklog_weekdays__wXocd {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
  margin-top: 0.25rem;
}

.ItBacklog_weekdayChip__imi9y {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: 1px solid #e6e8ef;
  background: #fafbff;
  border-radius: 999px;
  padding: 0.35rem 0.6rem;
  font-weight: 800;
  color: #333;
  cursor: pointer;
}
.ItBacklog_weekdayChip__imi9y input {
  transform: translateY(1px);
}
.ItBacklog_weekdayChip__imi9y:hover {
  border-color: rgba(52, 152, 219, 0.45);
  background: rgba(52, 152, 219, 0.06);
}`, "",{"version":3,"sources":["webpack://./src/Pages/ItBacklog/ItBacklog.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,8CAAA;AAEA,eAAA;AA2BA,SAAA;AACA;EACE,oBAAA;AAzBF;;AA4BA,4BAAA;AACA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;AAzBF;AA2BE;EALF;IAMI,0BAAA;EAxBF;AACF;;AA2BA;;EAtBE,gBAhBK;EAiBL,yBAAA;EACA,mBAAA;EACA,0CAjBO;EAuCP,aAAA;AArBF;;AAwBA;EACE,gBAAA;EACA,WAjDK;EAkDL,sBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,qCAAA;EACA,YAAA;AArBF;AAuBE;EALF;IAMI,0BAAA;EApBF;AACF;;AAuBA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WA1EK;AAsDP;;AAuBA;EACE,kBAAA;EACA,iBAAA;EACA,WA/EM;AA2DR;;AAuBA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,aAAA;EACA,2BAAA;AApBF;;AAuBA;EACE,iBAAA;EACA,WAjGM;AA6ER;;AAuBA,cAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AApBF;;AAuBA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;EACA,gBAAA;AApBF;AAsBE;EATF;IAUI,0BAAA;EAnBF;AACF;;AAsBA;EACE,gBAAA;EACA,WAnIK;AAgHP;;AAsBA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,WAAA;AAnBF;;AAsBA;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAnBF;;AAsBA;EACE,YAAA;AAnBF;;AAsBA,SAAA;AACA;EAjJE,gBAhBK;EAiBL,yBAAA;EACA,mBAAA;EACA,0CAjBO;EAiKP,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;AAhBF;;AAmBA;EACE,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAlLM;EAmLN,gBAAA;AAhBF;AAkBE;EACE,oCAAA;EACA,WAxLG;AAwKP;;AAoBA;EACE,oCAAA;EACA,sCAAA;EACA,WA/LK;AA8KP;;AAoBA,sBAAA;AACA;EAhLE,gBAhBK;EAiBL,yBAAA;EACA,mBAAA;EACA,0CAjBO;EAgMP,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,0BAAA;EACA,YAAA;AAdF;;AAiBA;EACE,WAAA;AAdF;;AAiBA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;AAdF;AAgBE;EACE,qCAAA;EACA,8CAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,uCAAA;EACA,WAAA;AAfF;AAiBE;EALF;IAMI,8BAAA;EAdF;AACF;AAgBE;EATF;IAUI,0BAAA;EAbF;AACF;;AAgBA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;AAbF;AAeE;EACE,qCAAA;EACA,8CAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,YAAA;EACA,yBAAA;AAdF;AAgBE;EALF;IAMI,2BAAA;EAbF;AACF;;AAgBA;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAbF;AAeE;EACE,sCAAA;AAbJ;;AAiBA;EACE,qCAAA;EACA,8CAAA;AAdF;;AAiBA,8BAAA;AACA;EACE,0CAAA;EACA,oCAAA;EACA,yDAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAdF;AAgBE;EACE,oCAAA;EACA,sCAAA;AAdJ;;AAkBA;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAfF;AAiBE;EACE,sCAAA;EACA,oCAAA;AAfJ;;AAmBA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;AAhBF;AAkBE;EACE,qCAAA;EACA,8CAAA;AAhBJ;;AAoBA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AAjBF;AAmBE;EACE,qCAAA;EACA,8CAAA;AAjBJ;;AAqBA;EACE,gBAAA;EACA,WAtVK;EAuVL,sBAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WA/VK;AA6UP;;AAqBA,WAAA;AACA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AAlBF;AAoBE;EANF;IAOI,0BAAA;EAjBF;AACF;;AAoBA;EA3VE,gBAhBK;EAiBL,yBAAA;EACA,mBAAA;EACA,0CAjBO;EA2WP,gBAAA;EACA,iBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,sBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,WA9XM;AAgXR;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAdF;AAgBE;EACE,2BAAA;EACA,2CAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AAfF;;AAkBA;EACE,+GAAA;EACA,gBAAA;EACA,WAjaM;AAkZR;;AAkBA;EACE,gBAAA;EACA,WAvaK;EAwaL,sBAAA;EACA,iBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AAfF;AAiBE;EALF;IAMI,0BAAA;EAdF;AACF;;AAiBA;EACE,kBAAA;EACA,WAvbM;AAyaR;;AAiBA;EACE,WA5bK;EA6bL,gBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AAdF;;AAiBA;EACE,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WApdM;AAscR;;AAiBA,UAAA;AACA;EACE,gBAAA;EAvcA,gBAhBK;EAiBL,yBAAA;EACA,mBAAA;EACA,0CAjBO;EAudP,cAAA;AAXF;;AAcA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AAXF;AAaE;;EAEE,sBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;AAXJ;AAcE;EACE,gBAAA;EACA,MAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAnfG;AAueP;;AAgBA;EACE,eAAA;AAbF;AAeE;EACE,oCAAA;AAbJ;;AAiBA;EACE,+GAAA;AAdF;;AAiBA,0BAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WA5gBK;EA6gBL,gBAAA;AAdF;;AAiBA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAvhBM;EAwhBN,gBAAA;AAdF;;AAiBA;EACE,oCAAA;EACA,sCAAA;EACA,wDAAA;AAdF;;AAiBA;EACE,oCAAA;EACA,sCAAA;EACA,wDAAA;AAdF;;AAiBA;EACE,oCAAA;EACA,sCAAA;EACA,sCAAA;AAdF;;AAiBA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WArjBM;EAsjBN,gBAAA;AAdF;;AAiBA;EACE,qCAAA;EACA,uCAAA;EACA,0DAAA;AAdF;;AAiBA;EACE,oCAAA;EACA,sCAAA;EACA,yDAAA;AAdF;;AAiBA;EACE,mCAAA;EACA,qCAAA;EACA,wDAAA;AAdF;;AAiBA,aAAA;AACA;EA1jBE,gBAhBK;EAiBL,yBAAA;EACA,mBAAA;EACA,0CAjBO;EA0kBP,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;AAXF;AAaE;EARF;IASI,0BAAA;EAVF;AACF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAVF;;AAaA;EACE,gBAAA;EACA,WAlmBK;EAmmBL,0BAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;AAVF;;AAaA;EACE,gBAAA;EACA,aAAA;EACA,0BAAA;EACA,SAAA;AAVF;;AAaA;;EA/lBE,gBAhBK;EAiBL,yBAAA;EACA,mBAAA;EACA,0CAjBO;EAgnBP,aAAA;AAPF;;AAUA,aAAA;AACA;EACE,aAAA;EACA,qCAAA;EACA,WAAA;AAPF;AASE;EALF;IAMI,WAAA;EANF;AACF;AAQE;EATF;IAUI,qCAAA;EALF;AACF;;AAQA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AALF;;AAQA;EACE,mBAAA;EACA,sCAAA;AALF;;AAQA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;AALF;;AAQA;EACE,gBAAA;EACA,WA/pBK;EAgqBL,eAAA;AALF;;AAQA;EACE,gBAAA;EACA,WApqBM;EAqqBN,kBAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AALF;;AAQA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AALF;AAOE;EACE,oCAAA;EACA,sCAAA;AALJ;;AASA;EACE,UAAA;EACA,WAAA;EACA,oBAAA;EACA,0CAAA;EACA,cAAA;AANF;;AASA;EACE,kBAAA;EACA,WA5sBK;EA6sBL,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AANF;;AASA;EACE,kBAAA;EACA,WAptBM;EAqtBN,gBAAA;AANF;;AASA;EACE,iBAAA;EACA,WA1tBM;EA2tBN,YAAA;AANF;;AASA,WAAA;AACA;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;AANF;;AASA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AANF;AAQE;;EAEE,gCAAA;EACA,+BAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;AANJ;AASE;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,WA5vBG;EA6vBH,kBAAA;AAPJ;;AAWA;EACE,gBAAA;EACA,OAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;AARF;;AAWA;EACE,gBAAA;EACA,WA5wBK;AAowBP;;AAWA;EACE,gBAAA;EACA,WAjxBK;EAkxBL,gBAAA;AARF;;AAWA;EACE,iBAAA;EACA,WAtxBM;EAuxBN,gBAAA;EACA,kBAAA;AARF;;AAWA;EACE,8BAAA;AARF;;AAWA;EACE,eAAA;EACA,YAAA;AARF;;AAWA;EACE,8BAAA;AARF;;AAWA;EACE,gBAAA;EACA,WA3yBK;EA4yBL,kBAAA;EACA,gBAAA;AARF;;AAWA;EACE,mBAAA;EACA,kBAAA;EACA,WAlzBM;EAmzBN,gBAAA;EACA,uBAAA;EACA,mBAAA;AARF;;AAWA,2DAAA;AACA;EACE,gBAAA;AARF;;AAUA;EACE,mCAAA;AAPF;;AASA;EACE,mCAAA;AANF;;AAQA;EACE,oCAAA;AALF;;AAOA;EACE,mCAAA;AAJF;;AAOA,kBAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AAJF;;AAOA,mBAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AAJF;;AAOA;EACE,WAAA;EACA,gBAAA;EAt1BA,gBAhBK;EAiBL,yBAAA;EACA,mBAAA;EACA,0CAjBO;EAs2BP,aAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;EACA,sBAAA;AADF;;AAIA;EACE,gBAAA;EACA,WA53BK;EA63BL,kBAAA;EACA,iBAAA;AADF;;AAIA;EACE,mBAAA;EACA,WAl4BM;EAm4BN,kBAAA;AADF;;AAIA;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AADF;AAGE;EACE,sCAAA;EACA,oCAAA;AADJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,qCAAA;EACA,WAAA;AAFF;AAIE;EALF;IAMI,qCAAA;EADF;AACF;AAGE;EATF;IAUI,0BAAA;EAAF;AACF;;AAGA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAp7BM;EAq7BN,gBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,WA37BK;EA47BL,gBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AAAF;;AAGA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,WA/8BK;EAg9BL,iBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AAAF;;AAGA,aAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAt+BK;EAu+BL,gBAAA;AAAF;AAEE;EACE,0BAAA;AAAJ;;AAIA;EACE,6BAAA;EACA,WA/+BM;AA8+BR;;AAIA,+BAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AADF;;AAIA;EACE,gBAAA;EACA,WAvgCK;AAsgCP;;AAIA;EACE,gBAAA;EACA,WA3gCM;AA0gCR;;AAIA,aAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AADF;;AAIA;EACE,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,YAAA;AADF;;AAIA;EACE,gBAAA;EACA,WAviCK;AAsiCP;;AAIA;EACE,kBAAA;EACA,WA3iCM;EA4iCN,gBAAA;AADF;;AAIA;EACE,mBAAA;EACA,WAljCK;EAmjCL,iBAAA;AADF;;AAIA;EACE,mBAAA;EACA,aAAA;EACA,+BAAA;EACA,WAAA;AADF;AAGE;EANF;IAOI,0BAAA;EAAF;AACF;;AAGA;EACE,mBAAA;EACA,WAlkCM;EAmkCN,kBAAA;AAAF;;AAGA,2BAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AAAF;AAEE;EALF;IAMI,0BAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAzmCK;AA0mCP;AACE;EACE,0BAAA;AACJ;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AAAF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAvoCK;EAwoCL,eAAA;AACF;AACE;EACE,0BAAA;AACJ;AAEE;EACE,sCAAA;EACA,oCAAA;AAAJ","sourcesContent":["/* src/pages/ItBacklog/ItBacklog.module.scss */\r\n\r\n/* Переменные */\r\n$primary: #3498db;\r\n$text: #333;\r\n$muted: #666;\r\n$bg: #f6f7fb;\r\n$card: #fff;\r\n$border: #e6e8ef;\r\n$shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\r\n\r\n$queue: #f39c12;\r\n$progress: #2980b9;\r\n$done: #2ecc71;\r\n\r\n$prioLow: #7f8c8d;\r\n$prioMed: #8e44ad;\r\n$prioHigh: #c0392b;\r\n\r\n$bpTablet: 980px;\r\n$bpMobile: 560px;\r\n\r\n@mixin card {\r\n  background: $card;\r\n  border: 1px solid $border;\r\n  border-radius: 12px;\r\n  box-shadow: $shadow;\r\n}\r\n\r\n/* Page */\r\n.page {\r\n  padding: 1rem 0 2rem;\r\n}\r\n\r\n/* Top summary + dept load */\r\n.topGrid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1.4fr;\r\n  gap: 1rem;\r\n\r\n  @media (max-width: $bpTablet) {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.summaryCard,\r\n.loadCard {\r\n  @include card;\r\n  padding: 1rem;\r\n}\r\n\r\n.summaryTitle {\r\n  font-weight: 800;\r\n  color: $text;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.summaryRow {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 0.75rem;\r\n\r\n  @media (max-width: $bpMobile) {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.summaryItem {\r\n  border: 1px solid $border;\r\n  border-radius: 10px;\r\n  padding: 0.75rem;\r\n  background: #fafbff;\r\n}\r\n\r\n.kpi {\r\n  font-size: 1.65rem;\r\n  font-weight: 900;\r\n  line-height: 1.1;\r\n  color: $text;\r\n}\r\n\r\n.kpiLabel {\r\n  margin-top: 0.2rem;\r\n  font-size: 0.9rem;\r\n  color: $muted;\r\n}\r\n\r\n.legend {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.summaryActions {\r\n  margin-top: 0.9rem;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.smallText {\r\n  font-size: 0.9rem;\r\n  color: $muted;\r\n}\r\n\r\n/* Load card */\r\n.loadHeader {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.loadList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.loadItem {\r\n  border: 1px solid $border;\r\n  border-radius: 12px;\r\n  padding: 0.75rem;\r\n  display: grid;\r\n  grid-template-columns: 1.2fr 1fr;\r\n  gap: 0.75rem;\r\n  background: #fff;\r\n\r\n  @media (max-width: $bpMobile) {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.loadDept {\r\n  font-weight: 800;\r\n  color: $text;\r\n}\r\n\r\n.loadMeta {\r\n  margin-top: 0.35rem;\r\n  display: flex;\r\n  gap: 0.4rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.loadRight {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.bars {\r\n  width: 100%;\r\n}\r\n\r\n.barTrack {\r\n  height: 10px;\r\n  border-radius: 999px;\r\n  background: #eef1f7;\r\n  position: relative;\r\n  overflow: hidden;\r\n  display: flex;\r\n}\r\n\r\n.barFill {\r\n  height: 100%;\r\n}\r\n\r\n/* Tabs */\r\n.tabs {\r\n  @include card;\r\n  margin-top: 1rem;\r\n  padding: 0.4rem;\r\n  display: inline-flex;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.tabBtn {\r\n  border: 1px solid transparent;\r\n  background: transparent;\r\n  border-radius: 10px;\r\n  padding: 0.55rem 0.85rem;\r\n  cursor: pointer;\r\n  font-weight: 800;\r\n  color: $muted;\r\n  transition: 0.2s;\r\n\r\n  &:hover {\r\n    background: rgba($primary, 0.08);\r\n    color: $text;\r\n  }\r\n}\r\n\r\n.tabActive {\r\n  background: rgba($primary, 0.12);\r\n  border-color: rgba($primary, 0.28);\r\n  color: $text;\r\n}\r\n\r\n/* Toolbar / filters */\r\n.toolbar {\r\n  @include card;\r\n  margin-top: 1rem;\r\n  padding: 0.75rem;\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.searchWrap {\r\n  width: 100%;\r\n}\r\n\r\n.search {\r\n  width: 100%;\r\n  border: 1px solid $border;\r\n  border-radius: 10px;\r\n  padding: 0.65rem 0.85rem;\r\n  font-size: 1rem;\r\n  outline: none;\r\n\r\n  &:focus {\r\n    border-color: rgba($primary, 0.7);\r\n    box-shadow: 0 0 0 3px rgba($primary, 0.12);\r\n  }\r\n}\r\n\r\n.filters {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr auto;\r\n  gap: 0.6rem;\r\n\r\n  @media (max-width: $bpTablet) {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  @media (max-width: $bpMobile) {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.select {\r\n  width: 100%;\r\n  border: 1px solid $border;\r\n  border-radius: 10px;\r\n  padding: 0.6rem 0.75rem;\r\n  background: #fff;\r\n  outline: none;\r\n\r\n  &:focus {\r\n    border-color: rgba($primary, 0.7);\r\n    box-shadow: 0 0 0 3px rgba($primary, 0.12);\r\n  }\r\n}\r\n\r\n.viewToggle {\r\n  display: flex;\r\n  gap: 0.35rem;\r\n  justify-content: flex-end;\r\n\r\n  @media (max-width: $bpTablet) {\r\n    justify-content: flex-start;\r\n  }\r\n}\r\n\r\n.toggleBtn {\r\n  border: 1px solid $border;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  padding: 0.55rem 0.75rem;\r\n  cursor: pointer;\r\n  transition: 0.2s;\r\n  font-weight: 800;\r\n\r\n  &:hover {\r\n    border-color: rgba($primary, 0.55);\r\n  }\r\n}\r\n\r\n.active {\r\n  border-color: rgba($primary, 0.8);\r\n  box-shadow: 0 0 0 3px rgba($primary, 0.12);\r\n}\r\n\r\n/* Buttons / inputs (shared) */\r\n.primaryBtn {\r\n  border: 1px solid rgba($primary, 0.45);\r\n  background: rgba($primary, 0.12);\r\n  color: darken($primary, 8%);\r\n  border-radius: 10px;\r\n  padding: 0.55rem 0.85rem;\r\n  cursor: pointer;\r\n  font-weight: 900;\r\n  transition: 0.2s;\r\n\r\n  &:hover {\r\n    background: rgba($primary, 0.18);\r\n    border-color: rgba($primary, 0.65);\r\n  }\r\n}\r\n\r\n.actionBtn {\r\n  border: 1px solid $border;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  padding: 0.5rem 0.75rem;\r\n  cursor: pointer;\r\n  transition: 0.2s;\r\n  font-weight: 800;\r\n\r\n  &:hover {\r\n    border-color: rgba($primary, 0.55);\r\n    background: rgba($primary, 0.06);\r\n  }\r\n}\r\n\r\n.input {\r\n  width: 100%;\r\n  border: 1px solid $border;\r\n  border-radius: 10px;\r\n  padding: 0.6rem 0.75rem;\r\n  background: #fff;\r\n  outline: none;\r\n\r\n  &:focus {\r\n    border-color: rgba($primary, 0.7);\r\n    box-shadow: 0 0 0 3px rgba($primary, 0.12);\r\n  }\r\n}\r\n\r\n.textarea {\r\n  width: 100%;\r\n  border: 1px solid $border;\r\n  border-radius: 10px;\r\n  padding: 0.65rem 0.75rem;\r\n  background: #fff;\r\n  outline: none;\r\n  resize: vertical;\r\n\r\n  &:focus {\r\n    border-color: rgba($primary, 0.7);\r\n    box-shadow: 0 0 0 3px rgba($primary, 0.12);\r\n  }\r\n}\r\n\r\n.label {\r\n  font-weight: 800;\r\n  color: $text;\r\n  margin-bottom: 0.35rem;\r\n  font-size: 0.92rem;\r\n}\r\n\r\n.sectionTitle {\r\n  margin-top: 0.8rem;\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 900;\r\n  color: $text;\r\n}\r\n\r\n/* Kanban */\r\n.kanban {\r\n  margin-top: 1rem;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 1rem;\r\n\r\n  @media (max-width: $bpTablet) {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.column {\r\n  @include card;\r\n  padding: 0.75rem;\r\n  min-height: 220px;\r\n}\r\n\r\n.columnHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-bottom: 0.6rem;\r\n  border-bottom: 1px solid $border;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.columnCount {\r\n  font-weight: 900;\r\n  color: $muted;\r\n}\r\n\r\n.cards {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.taskCard {\r\n  text-align: left;\r\n  border: 1px solid $border;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  padding: 0.75rem;\r\n  cursor: pointer;\r\n  transition: 0.15s;\r\n\r\n  &:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.07);\r\n  }\r\n}\r\n\r\n.taskTop {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  margin-bottom: 0.35rem;\r\n}\r\n\r\n.taskId {\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n  font-weight: 900;\r\n  color: $muted;\r\n}\r\n\r\n.taskTitle {\r\n  font-weight: 900;\r\n  color: $text;\r\n  margin-bottom: 0.45rem;\r\n  line-height: 1.25;\r\n}\r\n\r\n.taskMetaRow {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 0.5rem;\r\n\r\n  @media (max-width: $bpMobile) {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.taskMeta {\r\n  font-size: 0.92rem;\r\n  color: $muted;\r\n}\r\n\r\n.metaLabel {\r\n  color: $text;\r\n  font-weight: 800;\r\n}\r\n\r\n.taskBottom {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 0.45rem;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.tags {\r\n  margin-top: 0.55rem;\r\n  display: flex;\r\n  gap: 0.35rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.tag {\r\n  border: 1px solid $border;\r\n  background: #fafbff;\r\n  border-radius: 999px;\r\n  padding: 0.2rem 0.55rem;\r\n  font-size: 0.85rem;\r\n  color: $muted;\r\n}\r\n\r\n/* Table */\r\n.tableWrap {\r\n  margin-top: 1rem;\r\n  @include card;\r\n  overflow: auto;\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.95rem;\r\n\r\n  th,\r\n  td {\r\n    padding: 0.7rem 0.8rem;\r\n    border-bottom: 1px solid $border;\r\n    vertical-align: top;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  th {\r\n    position: sticky;\r\n    top: 0;\r\n    background: #fafbff;\r\n    z-index: 1;\r\n    text-align: left;\r\n    font-weight: 900;\r\n    color: $text;\r\n  }\r\n}\r\n\r\n.rowClickable {\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    background: rgba($primary, 0.06);\r\n  }\r\n}\r\n\r\n.mono {\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n}\r\n\r\n/* Badges / pills / prio */\r\n.badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  border-radius: 999px;\r\n  padding: 0.2rem 0.6rem;\r\n  font-size: 0.85rem;\r\n  border: 1px solid $border;\r\n  background: #fafbff;\r\n  color: $text;\r\n  font-weight: 800;\r\n}\r\n\r\n.pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  border-radius: 999px;\r\n  padding: 0.18rem 0.55rem;\r\n  font-size: 0.85rem;\r\n  border: 1px solid $border;\r\n  background: #fff;\r\n  color: $muted;\r\n  font-weight: 800;\r\n}\r\n\r\n.queue {\r\n  background: rgba($queue, 0.12);\r\n  border-color: rgba($queue, 0.35);\r\n  color: darken($queue, 18%);\r\n}\r\n\r\n.progress {\r\n  background: rgba($progress, 0.12);\r\n  border-color: rgba($progress, 0.35);\r\n  color: darken($progress, 10%);\r\n}\r\n\r\n.done {\r\n  background: rgba($done, 0.12);\r\n  border-color: rgba($done, 0.35);\r\n  color: darken($done, 12%);\r\n}\r\n\r\n.prio {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  border-radius: 999px;\r\n  padding: 0.18rem 0.55rem;\r\n  font-size: 0.85rem;\r\n  border: 1px solid $border;\r\n  background: #fff;\r\n  color: $muted;\r\n  font-weight: 900;\r\n}\r\n\r\n.low {\r\n  background: rgba($prioLow, 0.12);\r\n  border-color: rgba($prioLow, 0.35);\r\n  color: darken($prioLow, 10%);\r\n}\r\n\r\n.medium {\r\n  background: rgba($prioMed, 0.12);\r\n  border-color: rgba($prioMed, 0.35);\r\n  color: darken($prioMed, 6%);\r\n}\r\n\r\n.high {\r\n  background: rgba($prioHigh, 0.12);\r\n  border-color: rgba($prioHigh, 0.35);\r\n  color: darken($prioHigh, 6%);\r\n}\r\n\r\n/* Plan tab */\r\n.planToolbar {\r\n  @include card;\r\n  margin-top: 1rem;\r\n  padding: 0.75rem;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1.5fr;\r\n  gap: 0.75rem;\r\n\r\n  @media (max-width: $bpTablet) {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.monthNav {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.monthTitle {\r\n  font-weight: 900;\r\n  color: $text;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.planHint {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.planGrid {\r\n  margin-top: 1rem;\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 1rem;\r\n}\r\n\r\n.calendarCard,\r\n.matrixCard {\r\n  @include card;\r\n  padding: 1rem;\r\n}\r\n\r\n/* Calendar */\r\n.calendar {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, 1fr);\r\n  gap: 0.6rem;\r\n\r\n  @media (max-width: $bpTablet) {\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  @media (max-width: $bpMobile) {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n.dayCell {\r\n  border: 1px solid $border;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  padding: 0.6rem;\r\n  min-height: 110px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.weekend {\r\n  background: #fbfbfe;\r\n  border-color: rgba($border, 0.9);\r\n}\r\n\r\n.dayTop {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n}\r\n\r\n.dayNum {\r\n  font-weight: 900;\r\n  color: $text;\r\n  font-size: 1rem;\r\n}\r\n\r\n.dayDow {\r\n  font-weight: 900;\r\n  color: $muted;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.dayTasks {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.dayTaskChip {\r\n  width: 100%;\r\n  text-align: left;\r\n  border: 1px solid $border;\r\n  background: #fafbff;\r\n  border-radius: 10px;\r\n  padding: 0.35rem 0.45rem;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  transition: 0.15s;\r\n\r\n  &:hover {\r\n    background: rgba($primary, 0.08);\r\n    border-color: rgba($primary, 0.35);\r\n  }\r\n}\r\n\r\n.dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 999px;\r\n  border: 1px solid rgba($border, 0.9);\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.chipText {\r\n  font-size: 0.85rem;\r\n  color: $text;\r\n  font-weight: 800;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.more {\r\n  font-size: 0.82rem;\r\n  color: $muted;\r\n  font-weight: 800;\r\n}\r\n\r\n.dayEmpty {\r\n  font-size: 0.9rem;\r\n  color: $muted;\r\n  opacity: 0.8;\r\n}\r\n\r\n/* Matrix */\r\n.matrixWrap {\r\n  margin-top: 0.6rem;\r\n  overflow: auto;\r\n  border: 1px solid $border;\r\n  border-radius: 12px;\r\n}\r\n\r\n.matrix {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.9rem;\r\n  min-width: 980px;\r\n\r\n  th,\r\n  td {\r\n    border-bottom: 1px solid $border;\r\n    border-right: 1px solid $border;\r\n    padding: 0.45rem 0.45rem;\r\n    vertical-align: top;\r\n    background: #fff;\r\n  }\r\n\r\n  th {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 3;\r\n    background: #fafbff;\r\n    font-weight: 900;\r\n    color: $text;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.stickyCol {\r\n  position: sticky;\r\n  left: 0;\r\n  z-index: 4;\r\n  background: #fafbff;\r\n  min-width: 140px;\r\n  text-align: left !important;\r\n}\r\n\r\n.ownerCell {\r\n  font-weight: 900;\r\n  color: $text;\r\n}\r\n\r\n.headDay {\r\n  font-weight: 900;\r\n  color: $text;\r\n  line-height: 1.1;\r\n}\r\n\r\n.headDow {\r\n  font-size: 0.8rem;\r\n  color: $muted;\r\n  font-weight: 800;\r\n  margin-top: 0.1rem;\r\n}\r\n\r\n.weekendHead {\r\n  background: #f3f4fb !important;\r\n}\r\n\r\n.matrixCell {\r\n  min-width: 56px;\r\n  height: 46px;\r\n}\r\n\r\n.weekendCell {\r\n  background: #fbfbfe !important;\r\n}\r\n\r\n.cellHours {\r\n  font-weight: 900;\r\n  color: $text;\r\n  font-size: 0.92rem;\r\n  line-height: 1.1;\r\n}\r\n\r\n.cellTasks {\r\n  margin-top: 0.15rem;\r\n  font-size: 0.75rem;\r\n  color: $muted;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Intensity classes (referenced from calcIntensityClass) */\r\n.cell0 {\r\n  background: #fff;\r\n}\r\n.cell1 {\r\n  background: rgba($done, 0.10);\r\n}\r\n.cell2 {\r\n  background: rgba($queue, 0.10);\r\n}\r\n.cell3 {\r\n  background: rgba($progress, 0.12);\r\n}\r\n.cell4 {\r\n  background: rgba($prioHigh, 0.12);\r\n}\r\n\r\n/* Matrix legend */\r\n.matrixLegend {\r\n  margin-top: 0.75rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.legendBox {\r\n  width: 16px;\r\n  height: 12px;\r\n  border-radius: 4px;\r\n  border: 1px solid $border;\r\n  display: inline-block;\r\n}\r\n\r\n/* Modal (shared) */\r\n.modalBackdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.35);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1rem;\r\n  z-index: 9999;\r\n}\r\n\r\n.modal {\r\n  width: 100%;\r\n  max-width: 820px;\r\n  @include card;\r\n  padding: 1rem;\r\n  max-height: 85vh;\r\n  overflow: auto;\r\n}\r\n\r\n.modalHeader {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding-bottom: 0.75rem;\r\n  border-bottom: 1px solid $border;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.modalTitle {\r\n  font-weight: 900;\r\n  color: $text;\r\n  font-size: 1.15rem;\r\n  line-height: 1.25;\r\n}\r\n\r\n.modalSub {\r\n  margin-top: 0.25rem;\r\n  color: $muted;\r\n  font-size: 0.92rem;\r\n}\r\n\r\n.modalClose {\r\n  border: 1px solid $border;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  width: 38px;\r\n  height: 38px;\r\n  font-size: 1.4rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  transition: 0.15s;\r\n\r\n  &:hover {\r\n    border-color: rgba($primary, 0.55);\r\n    background: rgba($primary, 0.06);\r\n  }\r\n}\r\n\r\n.modalBody {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.9rem;\r\n}\r\n\r\n.modalGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 0.6rem;\r\n\r\n  @media (max-width: $bpTablet) {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  @media (max-width: $bpMobile) {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.modalCard {\r\n  border: 1px solid $border;\r\n  border-radius: 12px;\r\n  padding: 0.75rem;\r\n  background: #fafbff;\r\n}\r\n\r\n.modalLabel {\r\n  font-size: 0.85rem;\r\n  color: $muted;\r\n  font-weight: 900;\r\n}\r\n\r\n.modalValue {\r\n  margin-top: 0.35rem;\r\n  color: $text;\r\n  font-weight: 900;\r\n}\r\n\r\n.modalActions {\r\n  margin-top: 0.6rem;\r\n  display: flex;\r\n  gap: 0.35rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.modalSection {\r\n  border: 1px solid $border;\r\n  border-radius: 12px;\r\n  padding: 0.75rem;\r\n  background: #fff;\r\n}\r\n\r\n.modalText {\r\n  margin-top: 0.35rem;\r\n  color: $text;\r\n  line-height: 1.45;\r\n}\r\n\r\n.modalTags {\r\n  margin-top: 0.45rem;\r\n  display: flex;\r\n  gap: 0.35rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* Subtasks */\r\n.subtasks {\r\n  margin-top: 0.45rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.subtaskRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.55rem;\r\n  color: $text;\r\n  font-weight: 700;\r\n\r\n  input {\r\n    transform: translateY(1px);\r\n  }\r\n}\r\n\r\n.subtaskDone {\r\n  text-decoration: line-through;\r\n  color: $muted;\r\n}\r\n\r\n/* Schedule list (task modal) */\r\n.scheduleList {\r\n  margin-top: 0.45rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.scheduleItem {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  border: 1px solid $border;\r\n  background: #fafbff;\r\n  border-radius: 10px;\r\n  padding: 0.45rem 0.6rem;\r\n}\r\n\r\n.scheduleDate {\r\n  font-weight: 900;\r\n  color: $text;\r\n}\r\n\r\n.scheduleHours {\r\n  font-weight: 900;\r\n  color: $muted;\r\n}\r\n\r\n/* Comments */\r\n.comments {\r\n  margin-top: 0.45rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.commentCard {\r\n  border: 1px solid $border;\r\n  border-radius: 12px;\r\n  padding: 0.65rem 0.75rem;\r\n  background: #fafbff;\r\n}\r\n\r\n.commentTop {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.commentAuthor {\r\n  font-weight: 900;\r\n  color: $text;\r\n}\r\n\r\n.commentDate {\r\n  font-size: 0.85rem;\r\n  color: $muted;\r\n  font-weight: 800;\r\n}\r\n\r\n.commentText {\r\n  margin-top: 0.35rem;\r\n  color: $text;\r\n  line-height: 1.45;\r\n}\r\n\r\n.commentForm {\r\n  margin-top: 0.65rem;\r\n  display: grid;\r\n  grid-template-columns: 1fr auto;\r\n  gap: 0.6rem;\r\n\r\n  @media (max-width: $bpMobile) {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.mutedBlock {\r\n  margin-top: 0.35rem;\r\n  color: $muted;\r\n  font-size: 0.92rem;\r\n}\r\n\r\n/* Create task modal form */\r\n.formGrid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 0.75rem;\r\n\r\n  @media (max-width: $bpMobile) {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.field {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.fieldFull {\r\n  grid-column: 1 / -1;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.planMode {\r\n  display: flex;\r\n  gap: 0.35rem;\r\n  flex-wrap: wrap;\r\n  margin: 0.25rem 0 0.5rem;\r\n}\r\n\r\n.checkRow {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.55rem;\r\n  font-weight: 800;\r\n  color: $text;\r\n\r\n  input {\r\n    transform: translateY(1px);\r\n  }\r\n}\r\n\r\n.modalFooter {\r\n  margin-top: 0.9rem;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n}\r\n.weekdays {\r\n  display: flex;\r\n  gap: 0.4rem;\r\n  flex-wrap: wrap;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.weekdayChip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  border: 1px solid $border;\r\n  background: #fafbff;\r\n  border-radius: 999px;\r\n  padding: 0.35rem 0.6rem;\r\n  font-weight: 800;\r\n  color: $text;\r\n  cursor: pointer;\r\n\r\n  input {\r\n    transform: translateY(1px);\r\n  }\r\n\r\n  &:hover {\r\n    border-color: rgba($primary, 0.45);\r\n    background: rgba($primary, 0.06);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ItBacklog_page__pHSJG`,
	"topGrid": `ItBacklog_topGrid__jdlsQ`,
	"summaryCard": `ItBacklog_summaryCard__dCTLC`,
	"loadCard": `ItBacklog_loadCard__QMBUQ`,
	"summaryTitle": `ItBacklog_summaryTitle__BMwhW`,
	"summaryRow": `ItBacklog_summaryRow__EAgAL`,
	"summaryItem": `ItBacklog_summaryItem__l1pj1`,
	"kpi": `ItBacklog_kpi__SyXwh`,
	"kpiLabel": `ItBacklog_kpiLabel__jkUPI`,
	"legend": `ItBacklog_legend__3H9Pk`,
	"summaryActions": `ItBacklog_summaryActions__H8JaM`,
	"smallText": `ItBacklog_smallText__SuQVo`,
	"loadHeader": `ItBacklog_loadHeader__mJW1r`,
	"loadList": `ItBacklog_loadList__vQhnY`,
	"loadItem": `ItBacklog_loadItem__zUkEY`,
	"loadDept": `ItBacklog_loadDept__8NV2u`,
	"loadMeta": `ItBacklog_loadMeta__71bem`,
	"loadRight": `ItBacklog_loadRight__sCSSq`,
	"bars": `ItBacklog_bars__asgSr`,
	"barTrack": `ItBacklog_barTrack__HBygL`,
	"barFill": `ItBacklog_barFill__3FtFb`,
	"tabs": `ItBacklog_tabs__SzlNB`,
	"tabBtn": `ItBacklog_tabBtn__FTmBw`,
	"tabActive": `ItBacklog_tabActive__V8y1r`,
	"toolbar": `ItBacklog_toolbar__qp4Wx`,
	"searchWrap": `ItBacklog_searchWrap__n4Rtu`,
	"search": `ItBacklog_search__gS39s`,
	"filters": `ItBacklog_filters__4f4xS`,
	"select": `ItBacklog_select__hUuLk`,
	"viewToggle": `ItBacklog_viewToggle__lLTcY`,
	"toggleBtn": `ItBacklog_toggleBtn__5kFi9`,
	"active": `ItBacklog_active__mUeEA`,
	"primaryBtn": `ItBacklog_primaryBtn__C+7-D`,
	"actionBtn": `ItBacklog_actionBtn__doOIf`,
	"input": `ItBacklog_input__sI8xA`,
	"textarea": `ItBacklog_textarea__jRs7c`,
	"label": `ItBacklog_label__j-C7j`,
	"sectionTitle": `ItBacklog_sectionTitle__YpEoD`,
	"kanban": `ItBacklog_kanban__kBEFP`,
	"column": `ItBacklog_column__3YyFx`,
	"columnHeader": `ItBacklog_columnHeader__I8fgC`,
	"columnCount": `ItBacklog_columnCount__brEBK`,
	"cards": `ItBacklog_cards__uj4F6`,
	"taskCard": `ItBacklog_taskCard__gVDjd`,
	"taskTop": `ItBacklog_taskTop__lYqi1`,
	"taskId": `ItBacklog_taskId__nJA-I`,
	"taskTitle": `ItBacklog_taskTitle__MAiN0`,
	"taskMetaRow": `ItBacklog_taskMetaRow__wrOM9`,
	"taskMeta": `ItBacklog_taskMeta__RmXpn`,
	"metaLabel": `ItBacklog_metaLabel__IFfnC`,
	"taskBottom": `ItBacklog_taskBottom__zLhfF`,
	"tags": `ItBacklog_tags__Xjxgo`,
	"tag": `ItBacklog_tag__uEExO`,
	"tableWrap": `ItBacklog_tableWrap__OSMSn`,
	"table": `ItBacklog_table__raFyM`,
	"rowClickable": `ItBacklog_rowClickable__OYFDP`,
	"mono": `ItBacklog_mono__6qyI8`,
	"badge": `ItBacklog_badge__JyE25`,
	"pill": `ItBacklog_pill__9yEt1`,
	"queue": `ItBacklog_queue__yJX+i`,
	"progress": `ItBacklog_progress__j59OX`,
	"done": `ItBacklog_done__7Mc4I`,
	"prio": `ItBacklog_prio__CWR9r`,
	"low": `ItBacklog_low__dhEyo`,
	"medium": `ItBacklog_medium__WlseD`,
	"high": `ItBacklog_high__7CyhP`,
	"planToolbar": `ItBacklog_planToolbar__IG8VS`,
	"monthNav": `ItBacklog_monthNav__rTD8w`,
	"monthTitle": `ItBacklog_monthTitle__64OgX`,
	"planHint": `ItBacklog_planHint__XtrSB`,
	"planGrid": `ItBacklog_planGrid__G6Ng9`,
	"calendarCard": `ItBacklog_calendarCard__rCy6o`,
	"matrixCard": `ItBacklog_matrixCard__dLai2`,
	"calendar": `ItBacklog_calendar__2Nakd`,
	"dayCell": `ItBacklog_dayCell__gQsWW`,
	"weekend": `ItBacklog_weekend__675Ls`,
	"dayTop": `ItBacklog_dayTop__2+R0a`,
	"dayNum": `ItBacklog_dayNum__NfXmE`,
	"dayDow": `ItBacklog_dayDow__LJsMe`,
	"dayTasks": `ItBacklog_dayTasks__ERqnf`,
	"dayTaskChip": `ItBacklog_dayTaskChip__+GqCz`,
	"dot": `ItBacklog_dot__ZRltk`,
	"chipText": `ItBacklog_chipText__A-hMs`,
	"more": `ItBacklog_more__3dTdD`,
	"dayEmpty": `ItBacklog_dayEmpty__43KUG`,
	"matrixWrap": `ItBacklog_matrixWrap__IMXpt`,
	"matrix": `ItBacklog_matrix__ZbS-q`,
	"stickyCol": `ItBacklog_stickyCol__Py95v`,
	"ownerCell": `ItBacklog_ownerCell__k3A74`,
	"headDay": `ItBacklog_headDay__tc-t-`,
	"headDow": `ItBacklog_headDow__pCtij`,
	"weekendHead": `ItBacklog_weekendHead__LYIlL`,
	"matrixCell": `ItBacklog_matrixCell__4YA9y`,
	"weekendCell": `ItBacklog_weekendCell__AXMXB`,
	"cellHours": `ItBacklog_cellHours__o-Kyw`,
	"cellTasks": `ItBacklog_cellTasks__kq8DH`,
	"cell0": `ItBacklog_cell0__kmSaM`,
	"cell1": `ItBacklog_cell1__Rek77`,
	"cell2": `ItBacklog_cell2__5nbUB`,
	"cell3": `ItBacklog_cell3__uBgUI`,
	"cell4": `ItBacklog_cell4__L7y0E`,
	"matrixLegend": `ItBacklog_matrixLegend__3Fp-H`,
	"legendBox": `ItBacklog_legendBox__r70OX`,
	"modalBackdrop": `ItBacklog_modalBackdrop__2DP36`,
	"modal": `ItBacklog_modal__j9sYr`,
	"modalHeader": `ItBacklog_modalHeader__9FRrl`,
	"modalTitle": `ItBacklog_modalTitle__DLrX-`,
	"modalSub": `ItBacklog_modalSub__Eu9MV`,
	"modalClose": `ItBacklog_modalClose__reGbl`,
	"modalBody": `ItBacklog_modalBody__4KqEy`,
	"modalGrid": `ItBacklog_modalGrid__w83Mj`,
	"modalCard": `ItBacklog_modalCard__dWScF`,
	"modalLabel": `ItBacklog_modalLabel__stG9w`,
	"modalValue": `ItBacklog_modalValue__IAEtD`,
	"modalActions": `ItBacklog_modalActions__ezSqF`,
	"modalSection": `ItBacklog_modalSection__8pWiv`,
	"modalText": `ItBacklog_modalText__G5u3o`,
	"modalTags": `ItBacklog_modalTags__ZShe2`,
	"subtasks": `ItBacklog_subtasks__dJYn6`,
	"subtaskRow": `ItBacklog_subtaskRow__Afmxv`,
	"subtaskDone": `ItBacklog_subtaskDone__oLRMH`,
	"scheduleList": `ItBacklog_scheduleList__7VYcS`,
	"scheduleItem": `ItBacklog_scheduleItem__fYSiD`,
	"scheduleDate": `ItBacklog_scheduleDate__geLWi`,
	"scheduleHours": `ItBacklog_scheduleHours__NGrdb`,
	"comments": `ItBacklog_comments__r4gPB`,
	"commentCard": `ItBacklog_commentCard__nsw-K`,
	"commentTop": `ItBacklog_commentTop__mr2f+`,
	"commentAuthor": `ItBacklog_commentAuthor__WwH2D`,
	"commentDate": `ItBacklog_commentDate__qTCCy`,
	"commentText": `ItBacklog_commentText__uhRHA`,
	"commentForm": `ItBacklog_commentForm__bZ0R9`,
	"mutedBlock": `ItBacklog_mutedBlock__tssUK`,
	"formGrid": `ItBacklog_formGrid__FUP7E`,
	"field": `ItBacklog_field__TUY5D`,
	"fieldFull": `ItBacklog_fieldFull__GXNac`,
	"planMode": `ItBacklog_planMode__qDHnM`,
	"checkRow": `ItBacklog_checkRow__dSqeZ`,
	"modalFooter": `ItBacklog_modalFooter__ou2sq`,
	"weekdays": `ItBacklog_weekdays__wXocd`,
	"weekdayChip": `ItBacklog_weekdayChip__imi9y`
};
export default ___CSS_LOADER_EXPORT___;
